import { z } from 'zod';
import { objectId } from '../ObjectId';
import { chatContext } from './ChatContext';

import { chatMessage } from './ChatMessage';

export const chat = z.object({
    id: objectId,
    accountId: objectId,
    tenantId: objectId,
    sessionId: objectId,
    createdAt: z.coerce.date(),
    lastModifiedAt: z.coerce.date(),
    status: z.enum(['active', 'ended']),
    activeContext: chatContext,
    previousContexts: z.array(chatContext),
    messages: z.array(chatMessage)
});
export type Chat = z.infer<typeof chat>;
